import { CellId } from '@deepcell/dc_core_proto/deepcell_schema2_pb'
import ms from 'ms'
import { useQuery } from 'react-query'
import { UseQueryResult } from 'react-query/types/react/types'
import { getCellImageLayerURLs } from './api'

/**
 * Returns a signed URL for a specific image layer (e.g. "raw_crop") of a cell,
 * or undefined while loading / when unavailable. Internal-only at the API.
 *
 * The query key uses the cell's flat id fields so react-query can cache it; the
 * CellId proto is captured by the query function closure.
 */
export default function useCellImageLayerUrl(
  cellId: CellId | undefined,
  layerType: string,
  frame = 0,
  enabled = true
): UseQueryResult<string | undefined, unknown> {
  const keyParams = {
    number: cellId?.getNumber(),
    time: cellId?.getTime(),
    instrumentId: cellId?.getInstrumentId(),
    frame,
  }

  return useQuery(
    ['cellImageLayerUrl', keyParams, layerType],
    async () => {
      if (!cellId) return undefined
      const urls = await getCellImageLayerURLs([{ cellId, frame }], layerType)
      return urls[0]
    },
    {
      enabled: enabled && !!cellId && cellId.getNumber() !== undefined,
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: ms('1 hour'),
      staleTime: ms('1 hour'),
    }
  )
}
